<template lang='pug'>
  div
    v-btn.tight-button(icon @click.stop='showDialog = !showDialog')
      v-icon(:size='size') photo_library
    v-dialog(v-model='showDialog' :max-width='1000')
      v-carousel(:value='index' hide-delimiters)
        v-carousel-item(v-for='(test, i) in testRun.tests' v-if='hasScreen(test)' :key='i' :href='getImageUrl(testRun, test, i)' target='_blank')
          v-img(:src='getImageUrl(testRun, test, i)')
</template>

<script>
export default {
  name: 'BionicMetricsScreensCarousel',
  props: {
    testRun: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 24
    }
  },
  methods: {
    openTo(index) {
      this.index = index;
      this.showDialog = true;
    },
    getBaseUrl(testRun) {
      return `${process.env.VUE_APP_SCREENS_URL}/${testRun.testSuiteGuid}/${testRun.guid}${testRun.agentGuid ? `/${testRun.agentGuid}` : ''}`;
    },
    getImageUrl(testRun, test, i) {
      if (test.rerun) return `${this.getBaseUrl(testRun)}/${i}_${test.rerun}.png`;
      return `${this.getBaseUrl(testRun)}/${i}.png`;
    },
    hasScreen(test) {
      return test.status !== 'NO_DATA' && !test.isRunning;
    }
  },
  data() {
    return {
      index: 0,
      showDialog: false
    };
  }
};
</script>

<style scoped>
</style>
